var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-comp-popup",style:(`display: ${_vm.settings.display};top: ${_vm.settings.top}px; left: ${
      _vm.settings.left
    }px`)},[_c('ul',{staticClass:"map-comp-popup__list"},_vm._l((_vm.settings.values),function(item){return _c('li',{key:item.key,staticClass:"map-comp-popup__item"},[_c('div',{staticClass:"map-comp-popup__key"},[_vm._v(" "+_vm._s(item.key)+" ")]),_c('div',{staticClass:"map-comp-popup__value"},[_vm._v(" "+_vm._s(_vm.getValue(item.value))+" ")])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }